export function groupedImages(selector) {
  let _groupedImages = []
  let _group = []
  document.querySelectorAll(selector).forEach((el) => {
    if (el.querySelector('* > img')) {
      _group.push(el)
      if (!el.nextElementSibling || el.nextElementSibling.nodeName !== 'FIGURE') {
        _groupedImages.push(_group)
        _group = []
      }
    }
  })
  return _groupedImages
}

export function groupedImagesOnDocument() {
  return groupedImages('.content .typography > figure').forEach((group, groupNumber) => {

    let container = document.createElement('div')

    const appendImagesToGroupContainer = (fig, i) => {
      let isSingleImage = group.length === 1
      let link = document.createElement('a')

      if (isSingleImage) {
        // we have only one picture here
        container.classList.add('single-image')
        container.classList.add(...fig.classList)
        fig.classList.remove(...fig.classList)
      } else {
        link.classList.add(...fig.classList)
        fig.classList.remove(...fig.classList)
      }

      container.append(fig.cloneNode(true))

      if (i === 0) {
        fig.replaceWith(container)
      } else {
        fig.remove()
      }
    }

    if (group.length < 1) {
      return
    }

    container.classList.add('figures')
    if (group.length % 2 === 1) {
      container.classList.add('odd-count')
    }
    group.forEach(appendImagesToGroupContainer)

  })
}


